import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const getDeviceInfo = async () => {
  const storedId = localStorage.getItem("deviceId");
  const storedName = localStorage.getItem("displayName");

  if (storedId && storedName) {
    return {
      type: "other",
      deviceId: storedId,
      displayName: storedName,
      isTrusted: true,
      fireBaseToken: "dummy-token",
    };
  }

  const fp = await FingerprintJS.load();
  const result = await fp.get();

  const displayName = getDisplayName();
  const deviceId = `${result.visitorId}-${displayName
    .toLowerCase()
    .replace(/\s+/g, "-")}`;

  localStorage.setItem("deviceId", deviceId);
  localStorage.setItem("displayName", displayName);

  return {
    type: "other",
    deviceId,
    displayName,
    isTrusted: true,
    fireBaseToken: "dummy-token",
  };
};

function getDisplayName() {
  const ua = navigator.userAgent;
  let browser = "Unknown Browser";
  let os = "Unknown OS";

  if (ua.includes("Firefox")) browser = "Firefox";
  else if (ua.includes("Chrome") && !ua.includes("Edg")) browser = "Chrome";
  else if (ua.includes("Safari") && !ua.includes("Chrome")) browser = "Safari";
  else if (ua.includes("Edg")) browser = "Edge";

  if (ua.includes("Windows")) os = "Windows";
  else if (ua.includes("Mac OS")) os = "Mac OS";
  else if (ua.includes("Android")) os = "Android";
  else if (ua.includes("iPhone") || ua.includes("iPad")) os = "iOS";
  else if (ua.includes("Linux")) os = "Linux";

  return `${browser} on ${os}`;
}
